import type { CustomField } from '@/lib/api/types';

export type FieldValueDraft = { text: string; number: string; date: string; options: string[] };

/** Value body for `set_custom_field` (same shape as `PUT /assets/{id}/custom-fields/{fieldId}`), or null when incomplete. */
export function fieldValueBody(field: CustomField, d: FieldValueDraft): { value_text?: string; value_number?: number; value_date?: string; value_option_ids?: string[] } | null {
  switch (field.type) {
    case 'text':
      return d.text.trim() ? { value_text: d.text.trim() } : null;
    case 'number':
      return d.number.trim() !== '' && Number.isFinite(Number(d.number)) ? { value_number: Number(d.number) } : null;
    case 'date':
      return d.date ? { value_date: d.date } : null;
    case 'select':
      return d.options[0] ? { value_option_ids: [d.options[0]] } : null;
    case 'multi_select':
      return d.options.length ? { value_option_ids: d.options } : null;
    default:
      return null;
  }
}
